import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const sendToken = (token: string, navigate: Function, setLoading: Function) => {
  axios.post(`${API_URL}/auth/verify?token=${token}`, {})
    .then(response => {
      toast.success("Compte vérifié !", {
        className: "toast-success",
      });

      localStorage.setItem('sph-access', response.data.access_token);
      localStorage.setItem('sph-refresh', response.data.refresh_token);
      navigate('/');
    })
    .catch(async (error) => {
      console.error('An error occurred on fetching addresses token', error);
      // TODO: Improve display
      alert("Echec de la vérification de l'email utilisateur");
    })
    .finally(() => setLoading(false));
}

